import type { LinhaCrianca } from '../types';
import { idadeTexto, normalizar, ouTraco, termoAssinado, temCrianca } from '../utils';

interface Props {
  linhas: LinhaCrianca[];
  eventoNome: string;
}

// Versão para papel: uma linha por criança, A4 em pé, sem botões.
// Fica escondida na tela e aparece só na impressão.
export default function Impressao({ linhas, eventoNome }: Props) {
  const criancas = linhas.filter(temCrianca);

  return (
    <div className="hidden print:block">
      <header className="border-b border-black pb-1">
        <p className="text-[8pt] font-semibold uppercase tracking-wide">
          {eventoNome || 'Acampamento'} · equipe das crianças
        </p>
        <h1 className="text-[13pt] font-bold">Crianças no acampamento</h1>
        <p className="text-[8pt]">
          {criancas.length} {criancas.length === 1 ? 'criança' : 'crianças'} ·{' '}
          {new Date().toLocaleDateString('pt-BR')}
        </p>
      </header>

      <table className="mt-2 w-full border-collapse text-left">
        <thead>
          <tr className="border-b border-black text-[7pt] uppercase">
            <th className="py-1 pr-1 font-semibold">Nome</th>
            <th className="py-1 pr-1 font-semibold">Idade</th>
            <th className="py-1 pr-1 font-semibold">Alergias</th>
            <th className="py-1 pr-1 font-semibold">Alimentação</th>
            <th className="py-1 pr-1 font-semibold">Remédios e horários</th>
            <th className="py-1 pr-1 font-semibold">Febre/dor</th>
            <th className="py-1 pr-1 font-semibold">Saúde</th>
            <th className="py-1 pr-1 font-semibold">Responsável</th>
            <th className="py-1 font-semibold">Termo</th>
          </tr>
        </thead>
        <tbody>
          {criancas.map((linha, indice) => (
            <tr key={`${normalizar(linha.crianca)}-${indice}`} className="border-b border-black/40 align-top text-[7.5pt]">
              <td className="py-1 pr-1 font-semibold">{normalizar(linha.crianca)}</td>
              <td className="py-1 pr-1">{idadeTexto(linha)}</td>
              <td className="py-1 pr-1">{ouTraco(linha.alergias)}</td>
              <td className="py-1 pr-1">{ouTraco(linha.alimentacao)}</td>
              <td className="py-1 pr-1">{ouTraco(linha.remedios)}</td>
              <td className="py-1 pr-1">{ouTraco(linha.febre_dor)}</td>
              <td className="py-1 pr-1">{ouTraco(linha.saude)}</td>
              <td className="py-1 pr-1">{ouTraco(linha.responsavel)}</td>
              <td className="py-1">{termoAssinado(linha) ? 'Assinado' : 'Falta'}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p className="mt-2 text-[7.5pt]">
        Lembrete: remédios na embalagem original, com o nome da criança, a dose e os horários, e
        entregues à equipe das crianças na chegada.
      </p>
    </div>
  );
}